module.exports = __webpack_public_path__ + "9cced1d3945e8f54a190de80177cd71c.png";